import React from 'react';
import moment from 'moment';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Button } from './ui/button';
import { Calendar as CalendarIcon } from 'lucide-react';

const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

/** Selector mes/año con botón "Este mes" (default = mes actual). */
export function MonthYearPicker({ month, year, onChange, className = '' }) {
  const now = moment();
  const years = [];
  for (let y = now.year() + 1; y >= now.year() - 5; y--) years.push(y);

  const setThisMonth = () => onChange({ month: now.month() + 1, year: now.year() });
  const isCurrent = month === now.month() + 1 && year === now.year();

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="month-year-picker">
      <CalendarIcon size={16} className="text-[#2B4C3B]" />
      <Select value={String(month)} onValueChange={(v) => onChange({ month: Number(v), year })}>
        <SelectTrigger className="w-36" data-testid="picker-month-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MONTHS.map((m, i) => (
            <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={String(year)} onValueChange={(v) => onChange({ month, year: Number(v) })}>
        <SelectTrigger className="w-24" data-testid="picker-year-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {years.map((y) => (
            <SelectItem key={y} value={String(y)}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!isCurrent && (
        <Button
          variant="outline"
          size="sm"
          onClick={setThisMonth}
          data-testid="picker-current-month-btn"
          className="border-[#E8E5DD] text-[#2B4C3B]"
        >
          Este mes
        </Button>
      )}
    </div>
  );
}

/** Devuelve {start_date, end_date} en formato YYYY-MM-DD para un mes/año dado. */
export function monthRange(month, year) {
  const m = String(month).padStart(2, '0');
  return {
    start_date: `${year}-${m}-01`,
    end_date: moment(`${year}-${m}-01`).endOf('month').format('YYYY-MM-DD'),
  };
}
